import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { WorkGallery } from '../components/WorkGallery';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      ;
      (window as any).fbq('init', '1206060111307086');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-background text-white font-sans selection:bg-primary/30 selection:text-white" data-id="element-338">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-339">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1206060111307086&ev=PageView&noscript=1" alt="" data-id="element-340" />
      </noscript>
      <Hero data-id="element-341" />
      <ProblemSection data-id="element-342" />
      <WorkGallery data-id="element-343" />
      <Features data-id="element-344" />
      <Pricing data-id="element-345" />
      <Testimonials data-id="element-346" />
      <FAQ data-id="element-347" />
      <Footer data-id="element-348" />
      <WhatsAppButton data-id="element-349" />
    </div>;
}